import { render, staticRenderFns } from "./ReportCODOnDesBranch.vue?vue&type=template&id=bcefb366&"
import script from "./ReportCODOnDesBranch.vue?vue&type=script&lang=js&"
export * from "./ReportCODOnDesBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports